export { Phone as default } from './Phone';
